import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import NodeWrapper from "./NodeWrapper";
import useHandleConnected from "./useHandleConnected";
import { Loop } from "@mui/icons-material";

/**
 * Loop Node — Iterar sobre uma lista/array.
 *
 * data.loopSource: string — variavel contendo a lista (ex: "clientes")
 * data.loopItemVar: string — nome da variavel para cada item (ex: "cliente")
 * data.loopIndexVar: string — nome da variavel para o indice (ex: "i")
 * data.maxIterations: number — limite de iteracoes (seguranca, default 100)
 *
 * Saidas: handle "each" (executa para cada item), handle "done" (apos terminar)
 */
const LoopNode = memo(({ id, data, isConnectable, selected }) => {
  const getHandleClass = useHandleConnected(id);
  const source = data?.loopSource || "";
  const itemVar = data?.loopItemVar || "item";
  const maxIter = data?.maxIterations || 100;

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<Loop />}
      title="Loop"
      color="#6A1B9A"
      bgColor="#F3E5F5"
      noSource
      isConnectable={isConnectable}
      selected={selected}
      minWidth={210}
    >
      <div style={{
        background: "#fff", border: "1px solid #e0e0e0",
        borderRadius: 6, padding: "5px 10px",
        fontSize: 11, fontFamily: "'Fira Code', monospace",
      }}>
        <span style={{ color: "#999" }}>for </span>
        <span style={{ color: "#6A1B9A", fontWeight: 600 }}>{itemVar}</span>
        <span style={{ color: "#999" }}> in </span>
        <span style={{ color: "#1565C0", fontWeight: 600 }}>${"{" + source + "}"}</span>
      </div>

      <div style={{ fontSize: 10, color: "#999", marginTop: 4 }}>
        max: {maxIter} iteracoes
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 8 }}>
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "flex-end",
          gap: 6, position: "relative", paddingRight: 4,
        }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#6A1B9A", borderRadius: 4, padding: "2px 10px",
          }}>CADA ITEM</span>
          <Handle type="source" position={Position.Right} id="each"
            className={getHandleClass("source", "each")}
            style={{
              position: "absolute", top: "50%", right: -13,
              transform: "translateY(-50%)",
              cursor: "crosshair",
            }} isConnectable={isConnectable} />
        </div>
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "flex-end",
          gap: 6, position: "relative", paddingRight: 4,
        }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#4caf50", borderRadius: 4, padding: "2px 10px",
          }}>CONCLUIDO</span>
          <Handle type="source" position={Position.Right} id="done"
            className={getHandleClass("source", "done")}
            style={{
              position: "absolute", top: "50%", right: -13,
              transform: "translateY(-50%)",
              cursor: "crosshair",
            }} isConnectable={isConnectable} />
        </div>
      </div>
    </NodeWrapper>
  );
});

LoopNode.displayName = "LoopNode";
export default LoopNode;
